import React from "react";
import { Form, Input } from "antd";
import { getGetnet, upsertGetnet } from "./api";
import { GetnetConfig } from "./types";
import {
  CampoModo,
  CamposComunes,
  GatewayPanel,
  GatewayPanelProps,
} from "./GatewayPanel";
import { Subtitulo } from "./ui";

export const GetnetPanel: React.FC<GatewayPanelProps> = ({
  sellerCode,
  ...panel
}) => (
  <GatewayPanel<GetnetConfig>
    {...panel}
    title="Getnet"
    load={() => getGetnet(sellerCode)}
    save={(values) => upsertGetnet(sellerCode, values)}
    savedMessage="Getnet guardado"
  >
    <CamposComunes />
    <CampoModo />

    <Subtitulo>Credenciales</Subtitulo>
    <Form.Item label="ID de cliente" name="clientId">
      <Input />
    </Form.Item>
    <Form.Item label="Clave secreta" name="secretId">
      <Input.Password placeholder="••••••••" />
    </Form.Item>

    <Subtitulo>Webhook</Subtitulo>
    <Form.Item label="Usuario del webhook" name="userWebhook">
      <Input />
    </Form.Item>
    <Form.Item label="Contraseña del webhook" name="passwordWebhook">
      <Input.Password placeholder="••••••••" />
    </Form.Item>
  </GatewayPanel>
);
